import { Pipe, PipeTransform } from '@angular/core';

import {
    SelectedMetric,
    SelectedMetricMenu,
    SelectedMetricsMap,
} from '../components/metric-by-category-list/metric-by-category-list.interface';

/**
 * Check whether an item is selected
 *
 * value: A composite object of booleans organized by category, section, menu, and metric ids, marking which metrics
 *   have been selected.
 *
 * Params:
 *   metricId: A unique string identifying the metric, usually known as `internal_name`.
 *   categoryLabel: The label of the metric's category; this is the broadest way metrics are grouped.
 *   sectionLabel: The label of the metric's section; this is part of a category and can contain individual metrics or
 *     submenus of individual metrics.
 *   menuLabel: The label of the metric's menu, if the metric is part of a submenu. Not all metrics are part of submenus.
 *
 */
@Pipe({
    name: 'isItemSelected',
    standalone: false,
})
export class IsItemSelected implements PipeTransform {
    transform(
        value: SelectedMetricsMap,
        metricId: string,
        categoryLabel: string,
        sectionLabel: string,
        menuLabel?: string
    ): boolean {
        if (menuLabel) {
            return (value[categoryLabel][sectionLabel] as SelectedMetricMenu)[menuLabel][metricId];
        }
        return (value[categoryLabel][sectionLabel] as SelectedMetric)[metricId];
    }
}
